import { useEffect, useState } from 'react'

import { STORAGE_KEYS, getString, setString } from '#/shared/lib/storage'

const STORAGE_KEY = STORAGE_KEYS.devSample.key
const STORAGE_EVENT = 'order-form:dev-sample:change'

function readStored(): boolean {
  return getString(STORAGE_KEY) !== '0'
}

export function useDevSample(): {
  enabled: boolean
  setEnabled: (next: boolean) => void
} {
  const [enabled, setEnabledState] = useState<boolean>(() => readStored())

  useEffect(() => {
    const sync = () => setEnabledState(readStored())
    window.addEventListener(STORAGE_EVENT, sync)
    window.addEventListener('storage', sync)
    return () => {
      window.removeEventListener(STORAGE_EVENT, sync)
      window.removeEventListener('storage', sync)
    }
  }, [])

  const setEnabled = (next: boolean) => {
    setString(STORAGE_KEY, next ? '1' : '0')
    window.dispatchEvent(new Event(STORAGE_EVENT))
    setEnabledState(next)
  }

  return { enabled, setEnabled }
}
